import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { Card } from '@/common/components/Card/Card';
import { Grid } from '@/common/components/Grid/Grid';
import { Heading } from '@/common/components/Heading/Heading';
import { Icon } from '@/common/components/Icons/Icon';
import { LabeledValue } from '@/common/components/LabeledValue/LabeledValue';
import { Stack } from '@/common/components/Stack/Stack';
import { TextAction } from '@/common/components/TextAction/TextAction';
import { AnalyticsService } from '@/common/integrations/analytics/analytics.service';
import { IInsurancePolicy } from '@/common/integrations/menhir/employee/insurance/insurance.types';
import { formatDate } from '@/common/utils/date';

export const PolicyDetailsCard = ({ policy }: TPolicyDetailsCardProps) => {
  const { t } = useTranslation();

  return (
    <Card plain className="grow">
      <Stack gap="section">
        <Heading level={4}>{t('general.labels.policy_details')}</Heading>
        <Grid columnBasis="basis-[24rem]" gap="md">
          <LabeledValue
            label={t('dashboard.insurance_detail.card.policy.plan_name')}
            value={policy.product.plan.name}
          />
          <LabeledValue
            label={t('dashboard.insurance_detail.card.provider')}
            value={policy.product.provider.name}
          />
          <LabeledValue
            label={t('dashboard.insurance_detail.card.policy_number')}
            value={policy.policyNumber}
          />
          <LabeledValue
            label={t('dashboard.insurance_detail.card.renewal_date')}
            value={formatDate(policy.renewsOn)}
          />
        </Grid>
        {!!policy?.documents?.length && (
          <Stack gap="md">
            {policy.documents.map((document) => (
              <Stack horizontal gap="sm" align="center" key={document.name}>
                <View className="shrink-0">
                  <Icon icon="file-pdf" />
                </View>
                <TextAction
                  href={document.url}
                  hrefAttrs={{ target: '_blank' }}
                  onPress={() => {
                    AnalyticsService.trackCustomEvent(
                      'insurance_policy_details_documents_button_clicked'
                    );
                  }}
                  numberOfLines={1}
                  type="label"
                >
                  {t(document.name)}
                </TextAction>
              </Stack>
            ))}
          </Stack>
        )}
      </Stack>
    </Card>
  );
};

export type TPolicyDetailsCardProps = {
  policy: IInsurancePolicy;
};
